import { useState } from 'react';

import NextImage from 'next/image';

import { USStateObject } from '../../constants/USstates/constants';
import { Heading } from '../Heading/Heading';
import { SearchUSStateFromList } from '../Search/SearchUSStateFromList/SearchUSStateFromList';

import { StateLinks } from './components/StateLinks';
import { IAllStateWaterData } from './helpers/buildStateDataWaters';

interface IProps {
  stateWaterData: IAllStateWaterData;
  defaultUSState: USStateObject;
  usStates: USStateObject[];
}

export const FindUSFishingSpot = ({ stateWaterData, usStates, defaultUSState }: IProps) => {
  const [selectedState, setSelectedState] = useState<USStateObject>(defaultUSState);
  const ariaImageLabel = `${selectedState.stateName} silhouette`;

  return (
    <div
      className="my-sm mx-8 flex flex-col items-center sm:mx-auto sm:w-2/3"
      data-testid="FindUSFishingSpot"
    >
      <Heading variant="sm" as="h2" className="pb-2 text-center sm:pb-4">
        Find great fishing spots near you
      </Heading>

      <SearchUSStateFromList setSelectedState={setSelectedState} />

      <div className="mt-6 flex size-full flex-col-reverse sm:flex-row">
        <div className="flex w-full items-center justify-center sm:w-1/2">
          <NextImage
            className="w-full sm:w-1/2"
            src={selectedState.svgGray.src}
            alt={selectedState.stateName}
            width={125}
            height={75}
            aria-label={ariaImageLabel}
          />
        </div>
        {usStates.map(state => {
          const stateWatersList = stateWaterData.allStateWaterData.find(
            stateDataObj => stateDataObj.stateID === state.stateID,
          );
          return (
            <StateLinks
              selectedState={state}
              stateWatersList={stateWatersList}
              className={state.stateID === selectedState.stateID ? 'block' : 'hidden'}
              key={`FindUSFishingSpot-${state.stateID}`}
            />
          );
        })}
      </div>
    </div>
  );
};
